import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/helper/util.service';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { AnalyticsService } from '../../../analytics/analytics.service';
import { DashboardService } from '../../../analytics/dashboard-details/dashboard.service';
import _ from 'lodash';
import { ManageRequestsService } from '../../../manage-requests/manage-requests.service';
import { RequestAccessDialogComponent } from 'src/app/shared/request-access-dialog/request-access-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.scss',
})
export class ProductDetailsComponent implements OnInit {
  bussinessProductLine: any;
  companyId: any;
  userName: string;
  companyName: string;
  stepOneDetails: any;

  
   constructor(public route: ActivatedRoute, 
     public dashboardService: DashboardService,
     private analyticService: AnalyticsService,
     private spinnerService: NgxSpinnerService,
     private utilService: UtilService,
     private homePageService: HomePageService,
     public router: Router,
    private auth: AuthService,
  public manageRequestService: ManageRequestsService,
 private dialog: MatDialog,) {}

  product: any;
  userId: any='';
  successMessage: any;
  isUserLoggedIn: boolean;
  subscriptionMsg =
    'Please contact DMINT Administrator to get subscription of the same';
  errMsg: any;
  showErrorMessageWithPopup: boolean;
  closeSign: string;
  subscriptionDetails: any[] = [];
  analyticsModuleId: any;
  insightsModule: any;
  insightsData: any;
  headerId: any = '11';
  insightsModuleRecords: any[] = [];
  searchText: any='';
  currentPage=1;
  sortBy= 'created_date';
  sortType= 'desc';
  getinsightsModules: any[] = [];
  allInsightsModulesHeaders: any;
  allProdcuts: any[];
  moduleByteMap: { [key: string]: any } = {};
  dashboard: any;
  ngOnInit() {
    this.utilService.getHeaderId.subscribe((res:any) => this.headerId = res || this.headerId  );
    this.userDetails();
    this.userId = localStorage.getItem('userId')!='undefined'&&localStorage.getItem('userId')!=undefined?localStorage.getItem('userId'):'';
    this.isUserLoggedIn = localStorage.getItem('id') != 'undefined' 
                            && localStorage.getItem('id') != undefined ? true: false;
    this.analyticsModuleId = this.route.snapshot.params['id'];
    this.getHeader();
    this.utilService.moduleBytes.subscribe((mod) => {
        this.moduleByteMap = mod as Object;
    });
  }
getHeader(){
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.insightsModule = res;
      if (this.insightsModule.message === 'OK') {
        this.insightsData = this.insightsModule.result;
        this.insightsModuleRecords = [...this.insightsData];
        this.getUpdatedAnalyticsData()
        }
    });
  }
   getUpdatedAnalyticsData(flag=false){
      let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
  
      let payload: any = {
        "userId":userId,
        "headerId": this.headerId,
        "searchText": this.searchText,
        "categoryIds":  null,
        "regionIds":  null,
        "businessLineIds":  null,
        "functionIds":  null,
        "productLineIds":  null,
        "sortBy": this.sortBy,
        "sortType": this.sortType,
        "limit": 500,
        "page": this.currentPage
      }
      this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
        {
          next: (res: any) => {
            this.spinnerService.hide();
              this.getinsightsModules = res?.result;
              for (let modulerecord of this.insightsModuleRecords) {
                if (modulerecord.headerName == 'Data Products') {
                  this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
                }         
              }
              if (this.getinsightsModules?.length > 0 ) {
                this.getinsightsModules.forEach((ele: any) => {
                  let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                  if (index > -1) {
                    ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                    ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                  }
                })
                
                if (flag) {
                  this.allProdcuts = []
                  this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                  this.getinsightsModules = _.cloneDeep(this.allProdcuts);
               
                }
              } else {
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
        }
        this.subscriptionDetails=this.getinsightsModules;
        this.getModuleDetails();
          },
          error: (err) => {
            this.spinnerService.hide()
            this.utilService.SharingDataTextMessage.subscribe((res: any) => {
              this.errMsg = res
            })
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
          }
        }
      )
    }
  getModuleDetails(){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;
    let reqBody: { userId: any | null; moduleId: any } = {
          "userId": userId,
          "moduleId": this.analyticsModuleId
      }  
      this.analyticService.getAnalyticsDetailsById(reqBody).subscribe((res: any) => {      
      if (res && res.result) {
        let dashboardWithSubscription={};
        let index = this.subscriptionDetails.findIndex((x: any) => x.id||x.moduleId == this.analyticsModuleId)
          if (index > -1) {
            dashboardWithSubscription = {
            ...res.result,
            newlyAdded:this.subscriptionDetails[index].newlyAdded,
            subscription:this.subscriptionDetails[index].subscription,
            isInternal:this.subscriptionDetails[index].isInternal,
            accessCompleted:this.subscriptionDetails[index].accessCompleted,
            favorite:this.subscriptionDetails[index].favorite,
            moduleLink:this.subscriptionDetails[index].moduleLink,
            tags: this.subscriptionDetails[index].tags
          };
          }
        this.product = dashboardWithSubscription;
      }
     })
        
  }
  redirectToEmail() {
  let email = this.product?.moduleOwnerEmail;
  const mailtoLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}`;
  window.open(mailtoLink, '_blank');
}
  onPairingApicall(moduleLink: any) {
    this.spinnerService.hide();
    const token = localStorage.getItem('token');
    window.open(`${moduleLink}?token=${token}`, '_blank');
  }
  onSubscribe() { 
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
  }
    onSignIn() {
    this.utilService.onSignIn();
  }

onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }
  shareLink() {
    const baseURL = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(baseURL).then(() => {
        const msg = document.getElementById("copyMsg");
        msg.style.display = "block";
        setTimeout(() => msg.style.display = "none", 2000);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }

  userDetails(){
      this.userName = localStorage.getItem('userName');
      this.utilService.companyName.subscribe((res:any) => this.companyName = res);
      this.utilService.companyId.subscribe((res:any) => this.companyId = res);
  }

  onAccessPending() { 
    this.errMsg = `Please contact <a 
      href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
      target='_blank' 
      class='admin-email-link'>
      DMINT Administrator
    </a> to get access for the same`
      this.closeSign = 'OK';
      this.showErrorMessageWithPopup = true;
}

 onRequestAccessClick(module: any) {
   this.getStepOneDetails(module);
  }

  getStepOneDetails(module: any){
    this.manageRequestService.getDataForSteps(module.moduleId).subscribe((res: any) => {
          if(res){
            this.stepOneDetails = res.result;
            this.callRequestPopup(module,this.stepOneDetails)
        }
    });
  }
  callRequestPopup(module:any,stepDetails:any){
     const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: {
        module:module,
        stepDetails:stepDetails,
        title: `Request access to ${module.moduleName}`,
        panelClass: 'request-access-dialog',
        disableClose: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const apiPayload = {
          submittedByUserId: this.userId,
          companyId: this.companyId,
          headerId: this.headerId,
          moduleId: module?.moduleId,
          isModuleAttached: result?.isModuleAttached,
          userGroups: result?.userGroups
        };
        this.manageRequestService.createAccessRequest(apiPayload).subscribe({
          next: (response:any) => {
            if(response.code == 200){
              this.successMessage = response?.result;
              setTimeout(() => { this.successMessage = ''; }, 5000);
              this.getHeader();
            }
          },
          error: (error) => {
            this.errMsg = 'Failed to submit access request. Please try again.';
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
          }
        });
      }
    });
    
  }
}
